import Vue from 'vue';
import VuexPersistence from 'vuex-persist';
import Vuex from 'vuex';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  key: 'data',
  storage: localStorage
});

const getters = {
  pendingOrders: state => {
    if (state.status.length > 0) {
      return Object.keys(state.orders[state.status[0]]).length;
    }

    return 0;
  },
  noOrders: state => {
    for (const index in state.status) {
      const status = state.status[index];
      if (Object.keys(state.orders[status]).length > 0) {
        return false;
      }
    }

    return true;
  }
}

const mutations = {
  setSession(state, payload) {
    state.session = payload;
  },
  setInSession(state, payload) {
    Vue.set(state, 'session', { ...state.session, ...payload })
  },
  unsetSession(state) {
    state.session = null;
    state.onValueListener = null;
    state.status = [];
    state.orders = {
      addedListener: null,
      changedListener: null,
      removedListener: null,
      inconsistents: {}
    };
    state.realtimeOrdersStatus = {};
  },
  setStatus(state, payload) {
    state.status = payload.statusArray
    payload.statusArray.map((status) => {
      Vue.set(state.orders, [status], {});
    });
  },
  setOrders(state, payload) {
    const incons = {};

    payload.orders.map((order) => {
      order.downloaded = true;

      if (state.realtimeOrdersStatus[order.entity_id] !== undefined) {
        const status = state.realtimeOrdersStatus[order.entity_id].Status;

        Vue.set(state.orders[status], order.entity_id, order);
      } else {
        incons[order.entity_id] = {
          Orden: true,
          Estatus: ""
        };
      }
    });

    Object.keys(state.realtimeOrdersStatus).map((orderId) => {
      const arrayExists = payload.orders.filter((order) => {
        return order.entity_id == orderId;
      });

      if (arrayExists.length == 0) {
        incons[orderId] = {
          Orden: false,
          Estatus: state.realtimeOrdersStatus[orderId].Status
        };
      }
    });
    
    state.orders.inconsistents = incons;
  },
  setOrderToDownload(state, payload) {
    Vue.set(state.orders[state.status[0]], payload.id, payload.order);
  },
  setOrderStatus(state, payload) {
    const nStatusIndex = state.status.indexOf(payload.status);

    if (nStatusIndex > -1) {
      const bIndex = (nStatusIndex > 0) ? nStatusIndex - 1 : nStatusIndex;
      const from = state.status[bIndex];
      const to = state.status[nStatusIndex];

      const orderToChange = state.orders[from][payload.id];
      orderToChange.status = payload.status;
      Vue.set(state.orders[to], payload.id, orderToChange);
      Vue.delete(state.orders[from], payload.id);
    }
  },
  setRealtimeStatus(state, payload) {
    Vue.set(state.realtimeOrdersStatus, payload.id, payload.order);
  },
  setOrderDownloaded(state, payload) {
    if (state.orders[state.status[0]][payload.id] !== undefined) {
      payload.order.realtimeId = state.orders[state.status[0]][payload.id].realtimeId;
      Vue.set(state.orders[state.status[1]], [payload.id], payload.order);
      Vue.delete(state.orders[state.status[0]], payload.id);
    }
  },
  unsetOrder(state, payload) {
    const nStatusIndex = state.status.indexOf(payload.status);
    if (nStatusIndex > -1) {
      Vue.delete(state.orders[state.status[nStatusIndex]], payload.id);
      Vue.delete(state.realtimeOrdersStatus, payload.id);
    }
  },
  resolve(state, payload) {
    payload.inconsistenciesResponse.map((order) => {
      if (order != null) {
        switch (order.Status) {
          case 'Alredy_Completed':
            Vue.delete(state.orders.inconsistents, order.id);
            break;
          case 'Complete_Lista':
            if (order.ExtraData !== undefined) {
              Vue.set(state.orders.Lista, [order.id], { ...order.ExtraData, ...{downloaded: true} });
            } else {
              order.inconsistent = true;
              Vue.set(state.orders.Lista, [order.id], order);
            }
            Vue.delete(state.orders.inconsistents, order.id);
            break;
          case 'Incorrect_Subsidiary':
            Vue.delete(state.orders.inconsistents, order.id);
            break;
          case 'Not_Created_When_Order_Placed':
            Vue.delete(state.orders.inconsistents, order.id);
            break;
          case 'Created_In_Incorrect_Subsidiary':
            Vue.delete(state.orders.inconsistents, order.id);
            break;
          case 'Order_Closed':
            order.inconsistent = true;
            Vue.set(state.orders.Lista, [order.id], order);
            Vue.delete(state.orders.inconsistents, order.id);
            break;
          case 'Order_Canceled':
            order.inconsistent = true;
            Vue.set(state.orders.Lista, [order.id], order);
            Vue.delete(state.orders.inconsistents, order.id);
            break;
          case 'Order_Holded':
            order.inconsistent = true;
            Vue.set(state.orders.Lista, [order.id], order);
            Vue.delete(state.orders.inconsistents, order.id);
            break;
          case 'Order_Suspect_Fraud':
            order.inconsistent = true;
            Vue.set(state.orders.Lista, [order.id], order);
            Vue.delete(state.orders.inconsistents, order.id);
            break;
          default:
            order.inconsistent = false;
            Vue.set(state.orders.Nueva, [order.id], order);
            Vue.delete(state.orders.inconsistents, order.id);
            break;
        }
      }
    });
  },
  setInInconsistents(state, payload) {
    Vue.set(
      state.orders.inconsistents,
      [payload.id],
      {
        Orden: false,
        Estatus: payload.order.status
      }
    );
    Vue.delete(state.orders[state.status[1]], payload.id);
  }
};

const actions = {
  signIn({ commit }, { storeId, storePickUpCode, defaultShipping, category, token }) {
    const userObj = { storeId, storePickUpCode, defaultShipping, category, token };

    commit('setSession', userObj);
  },
  handleStatus({ commit }, { statusArray }) {
    commit('setStatus', { statusArray });
  },
  signOut({ commit }) {
    commit('unsetSession');
  },
  handleOrders({ commit }, { orders }) {
    commit('setOrders', { orders });
  },
  addNewOrder({ commit }, { id, order }) {
    commit('setOrderToDownload', { id, order });
  },
  updateOrder({ commit }, { id, status }) {
    commit('setOrderStatus', { id, status });
  },
  updateDownloadedOrder({ commit }, { id, order }) {
    commit('setOrderDownloaded', { id, order });
    if (!order.downloaded) {
      commit('setInInconsistents', { id, order });
    }
  },
  setRealtimeOrderStatus({ commit }, { id, order }) {
    commit('setRealtimeStatus', { id, order });
  },
  removeOrder({ commit }, { id, status }) {
    commit('unsetOrder', { id, status });
  },
  handleInconsistencies({ commit }, { inconsistenciesResponse }) {
    commit('resolve', { inconsistenciesResponse });
  },
  addToSession({ commit }, info) {
    commit('setInSession', info);
  },
};

const store = new Vuex.Store({
  state: {
    session: null,
    onValueListener: null,
    status: [],
    orders: {
      addedListener: null,
      changedListener: null,
      removedListener: null,
      inconsistents: {}
    },
    realtimeOrdersStatus: {}
  },
  mutations,
  actions,
  getters,
  plugins: [vuexLocal.plugin]
});

export default store;